import Aauthority from '@/components/Aauthority';
import './index.css';

export default {
  name: 'Acards',
  components: {
    Aauthority,
  },
  props: {
    data: { type: Array, default: () => null },
    items: { type: Array, default: () => null },
    config: { type: Array, default: () => null },
    option: { type: Array, default: () => null },
    options: { type: Array, default: () => null },
    routes: { type: String, default: () => '' },
    color: { type: String, default: () => 'rgba(0, 0, 0, 0.6)' },
    background: { type: String, default: () => '#eeeeee' },
  },
  methods: {
    select(path) {
      this.$emit('select', path);
    },
  },
  render() {
    const data = this.options || this.option || this.config || this.items || this.data || [];
    return (
      <div>
        <el-row gutter={40}>
          {data.length > 0 && data.map((a, b) => {
            if (this.routes && this.routes != '') {
              return (
                <Aauthority route={`${a.id}`} routes={this.routes}>
                  <el-col span={6} key={b}>
                    <a
                      class="b-card"
                      on-click={() => this.select(a.path)}
                      style={{ color: a.color, background: a.background, ...a.style }}
                    >
                      <div class="b-card-container">
                        <div><i class="el-icon-edit-outline" />{a.text || a.name}</div>
                      </div>
                    </a>
                  </el-col>
                </Aauthority>
              );
            } else {
              return (
                <el-col span={6} key={b}>
                  <a
                    class="b-card"
                    on-click={() => this.select(a.path)}
                    style={{ color: a.color, background: a.background, ...a.style }}
                  >
                    <div class="b-card-container">
                      <div><i class="el-icon-edit-outline" />{a.text || a.name}</div>
                    </div>
                  </a>
                </el-col>
              );
            }
          })}
        </el-row>
      </div>
    );
  }
}